import type { ButtonVariantType } from 'cpool-components/input/Button/types';
import { AGGREGATE_NAMES } from 'cpool-constants';
import type { SchemaUserResolver_GetAclPermissions } from 'cpool-tables/backend-resolvers';

import { type ChangeAdviserLead, ChangeAdviserModal } from './ChangeAdviserModal';
import { ChangeTriggerButton } from './ChangeTriggerButton';

type Props = {
    iconOnly?: boolean;
    lead: ChangeAdviserLead;
    originalLoanRequestId?: string;
    permissions?: SchemaUserResolver_GetAclPermissions;
    variant?: ButtonVariantType;
};

export const ChangeAdviserButton: React.FC<Props> = ({
    iconOnly = false,
    lead,
    originalLoanRequestId,
    permissions,
    variant,
}) => (
    <ChangeTriggerButton
        disabled={!permissions?.commands[AGGREGATE_NAMES.LOAN_REQUEST].assignToUser}
        iconOnly={iconOnly}
        renderModal={({ onClose, open }) => (
            <ChangeAdviserModal
                lead={lead}
                onClose={onClose}
                open={open}
                originalLoanRequestId={originalLoanRequestId}
            />
        )}
        testId="change-adviser-button"
        variant={variant}
    />
);
